<template>
    <div class="images">
        <div class="text">
            <div class="title">
                水源热泵系统流程图
            </div>
            <img class="po-a" src="@/assets/images/cockpit/板式换热器.png"
                style="width: 79px;height: 130px; left: 175px; top: 101px">
            <img class="po-a" src="@/assets/images/cockpit/空调用户.png"
                style="width: 206px;height: 68px; left: 542px; top: 92px">
            <img class="po-a" src="@/assets/images/cockpit/采暖用户.png"
                style="width: 113px;height: 86px; left: 313px; top: 171px">
            <img class="po-a" src="@/assets/images/cockpit/分水器.png"
                style="width: 113px;height: 35px; left: 497px; top: 212px">
            <img class="po-a" src="@/assets/images/cockpit/分水器.png"
                style="width: 113px;height: 35px; left: 370px; top: 330px">
            <img class="po-a" src="@/assets/images/cockpit/集水器.png"
                style="width: 86px;height: 36px; left: 702px; top: 213px">
            <img class="po-a" src="@/assets/images/cockpit/集水器.png"
                style="width: 86px;height: 36px; left: 266px; top: 330px">
            <img class="po-a" src="@/assets/images/cockpit/冷却塔.png"
                style="width: 104px;height: 105px; left: 813px; top: 125px">
            <img class="po-a" src="@/assets/images/cockpit/高温机组.png"
                style="width: 113px;height: 113px; left: 249px; top: 480px">
            <img class="po-a" src="@/assets/images/cockpit/超高温机组.png"
                style="width: 88px;height: 98px; left: 381px; top: 483px">
            <img class="po-a" src="@/assets/images/cockpit/常温机组.png"
                style="width: 59px;height: 111px; left: 514px; top: 387px">
            <img class="po-a" src="@/assets/images/cockpit/常温机组.png"
                style="width: 59px;height: 111px; left: 591px; top: 387px">
            <img class="po-a" src="@/assets/images/cockpit/常温机组.png"
                style="width: 59px;height: 111px; left: 668px; top: 387px">
            <img class="po-a" src="@/assets/images/cockpit/常温机组.png"
                style="width: 59px;height: 111px; left: 746px; top: 387px">
            <img class="po-a" src="@/assets/images/cockpit/开采井.png"
                style="width: 78px;height: 53px; left: 23px; top: 732px">
            <img class="po-a" src="@/assets/images/cockpit/除砂器.png"
                style="width: 60px;height: 132px; left: 142px; top: 657px">
            <img class="po-a" src="@/assets/images/cockpit/板式换热器.png"
                style="width: 72px;height: 117px; left: 341px; top: 683px">
            <img class="po-a" src="@/assets/images/cockpit/板式换热器.png"
                style="width: 72px;height: 117px; left: 616px; top: 683px">
            <img class="po-a" src="@/assets/images/cockpit/回灌井.png"
                style="width: 96px;height: 65px; left: 813px; top: 716px">
            <span class="po-a name" style="left: 46px; top: 126px">市政管网给水</span>
            <span class="po-a name" style="left: 51px; top: 201px">生活热水(洗浴)</span>
            <span class="po-a name" style="left: 184px; top: 230px">板式换热器</span>
            <span class="po-a name" style="left: 345px; top: 261px">采暖用户</span>
            <span class="po-a name" style="left: 620px; top: 172px">空调用户</span>
            <span class="po-a name" style="left: 517px; top: 254px">分水器</span>
            <span class="po-a name" style="left: 713px; top: 254px">集水器</span>
            <span class="po-a name" style="left: 835px; top: 231px">冷却塔</span>
            <span class="po-a name" style="left: 399px; top: 368px">分水器</span>
            <span class="po-a name" style="left: 272px; top: 368px">集水器</span>
            <span class="po-a name" style="left: 272px; top: 588px">高温机组</span>
            <span class="po-a name" style="left: 399px; top: 588px">超高温机组</span>
            <span class="po-a name" style="left: 511px; top: 505px">常温机组</span>
            <span class="po-a name" style="left: 588px; top: 505px">常温机组</span>
            <span class="po-a name" style="left: 665px; top: 505px">常温机组</span>
            <span class="po-a name" style="left: 743px; top: 505px">常温机组</span>
            <span class="po-a name" style="left: 27px; top: 796px">采集井</span>
            <span class="po-a name" style="left: 140px; top: 796px">除砂器</span>
            <span class="po-a name" style="left: 340px; top: 796px">板式换热器</span>
            <span class="po-a name" style="left: 619px; top: 796px">板式换热器</span>
            <span class="po-a name" style="left: 834px; top: 796px">回灌井</span>
            <span class="po-a num" style="left: 530px; top: 373px">#1</span>
            <span class="po-a num" style="left: 610px; top: 373px">#2</span>
            <span class="po-a num" style="left: 690px; top: 373px">#3</span>
            <span class="po-a num" style="left: 760px; top: 373px">#4</span>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#44bcc7'"
                style="width: 122px; height: 15px; left: 45px; top: 150px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'20s'" :color="'#44bcc7'"
                style="width: 15px; height: 408px; left: 204px; top: 265px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#44bcc7'"
                style="width: 55px; height: 15px; left: 158px; top: 258px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#44bcc7'"
                style="width: 15px; height: 63px; left: 152px; top: 203px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#44bcc7'"
                style="width: 180px; height: 15px; left: 498px; top: 617px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'20s'" :color="'#44bcc7'"
                style="width: 15px; height: 335px; left: 488px; top: 291px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#44bcc7'"
                style="width: 24px; height: 15px; left: 493px; top: 281px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#44bcc7'"
                style="width: 89px; height: 15px; left: 739px; top: 281px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'20s'" :color="'#44bcc7'"
                style="width: 15px; height: 313px; left: 820px; top: 291px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'20s'" :color="'#44bcc7'"
                style="width: 275px; height: 15px; left: 552px; top: 594px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#ff0303'"
                style="width: 142px; height: 15px; left: 25px; top: 185px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#ff0303'"
                style="width: 28px; height: 15px; left: 101px; top: 734px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#ff0303'"
                style="width: 105px; height: 15px; left: 208px; top: 734px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#ff0303'"
                style="width: 167px; height: 15px; left: 422px; top: 734px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#ff0303'"
                style="width: 88px; height: 15px; left: 695px; top: 734px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'7s'" :color="'#9b4b1e'"
                style="width: 12px; height: 15px; left: 263px; top: 174px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 122px; left: 266px; top: 184px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'7s'" :color="'#9b4b1e'"
                style="width: 20px; height: 15px; left: 299px; top: 202px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 97px; left: 289px; top: 208px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 85px; left: 419px; top: 232px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 170px; left: 447px; top: 147px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 182px; height: 15px; left: 274px; top: 137px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 77px; left: 289px; top: 400px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 77px; left: 420px; top: 400px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 77px; left: 289px; top: 622px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#9b4b1e'"
                style="width: 15px; height: 77px; left: 420px; top: 622px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#ffaa00'"
                style="width: 37px; height: 15px; left: 552px; top: 697px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#ffaa00'"
                style="width: 15px; height: 138px; left: 544px; top: 568px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'20s'" :color="'#ffaa00'"
                style="width: 226px; height: 15px; left: 552px; top: 562px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSped="'3s'" :color="'#ffaa00'"
                style="width: 15px; height: 15px; left: 535px; top: 562px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#ffaa00'"
                style="width: 15px; height: 44px; left: 529px; top: 527px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#ffaa00'"
                style="width: 15px; height: 44px; left: 610px; top: 527px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#ffaa00'"
                style="width: 15px; height: 44px; left: 688px; top: 527px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#ffaa00'"
                style="width: 15px; height: 44px; left: 768px; top: 527px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 126px; left: 670px; top: 554px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 80px; height: 15px; left: 676px; top: 547px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 157px; height: 15px; left: 520px; top: 547px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 20px; left: 670px; top: 533px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 20px; left: 590px; top: 533px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 20px; left: 514px; top: 533px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 20px; left: 747px; top: 533px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 40px; left: 719px; top: 170px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 60px; left: 732px; top: 274px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 182px; height: 15px; left: 557px; top: 327px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 50px; height: 15px; left: 739px; top: 327px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 40px; left: 550px; top: 333px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 40px; left: 630px; top: 333px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 40px; left: 705px; top: 333px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#999999'"
                style="width: 15px; height: 40px; left: 780px; top: 333px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 15px; height: 40px; left: 545px; top: 170px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 15px; height: 37px; left: 545px; top: 274px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 205px; height: 15px; left: 551px; top: 305px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 30px; height: 15px; left: 521px; top: 305px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 15px; height: 60px; left: 515px; top: 312px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 15px; height: 60px; left: 590px; top: 312px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 15px; height: 60px; left: 665px; top: 312px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#fff806'"
                style="width: 15px; height: 60px; left: 747px; top: 312px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="true" :animationSpeed="'10s'" :color="'#06ff0c'"
                style="width: 335px; height: 15px; left: 552px; top: 663px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="false" :animationSpeed="'10s'" :color="'#06ff0c'"
                style="width: 15px; height: 400px; left: 878px; top: 271px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="true" :isReverse="false" :animationSpeed="'10s'" :color="'#06ff0c'"
                style="width: 170px; height: 15px; left: 679px; top: 637px;"></scrollLine>
            <scrollLine class="po-a" :isHorizontal="false" :isReverse="true" :animationSpeed="'10s'" :color="'#06ff0c'"
                style="width: 15px; height: 387px; left: 840px; top: 259px;"></scrollLine>
        </div>
    </div>
</template>
<script>
import scrollLine from '@/components/scrollLine';
import * as echarts from "echarts";
import axios from 'axios';
export default {
    props: {
    },
    components: {
        scrollLine
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
/*引入字体*/
@font-face {
    /*自定义文字名称*/
    font-family: "yj";
    /*字体文件的路径*/
    src: url("./1.TTF");
}

@font-face {
    /*自定义文字名称*/
    font-family: "zanku";
    /*字体文件的路径*/
    src: url("@/assets/font/站酷文艺体.ttf");
}

.images::v-deep {
    height: 940px;

    .text {
        margin-top: 10px;
        width: 100%;
        height: 910px;
        background-image: url(@/assets/images/cockpit/bj5.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: 10px;
        position: relative;

        >.title {
            text-align: center;
            margin: 20px 0 0 0;
            font-size: 30px;
            font-family: "zanku";
            color: #44bcc7;
        }

        >.name {
            color: #fff;
            border: #fff 1px solid;
            font-size: 14px;
            min-width: 70px;
            text-align: center;
        }
        >.num{
            color: #fff;
            font-size: 14px;
        }
    }
}
</style>